import http from './http'

const SupportTicket = {
  createOne: (data) => http.post('/api/support-tickets/', { data }),
  scheduleEvent: (data) => http.post('/api/support-tickets/school-event/', { data }),
  contactSales: (data) => http.post('/api/support-tickets/contact-sales/', { data })
}

export default SupportTicket;
